import script from "./Stoch.vue?vue&type=script&lang=js"
export * from "./Stoch.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__